/**
 * @generated SignedSource<<988f36c7e9bf3e951137674b9ef54912>>
 * @relayHash a2c0c16f16d55ac0bad51490b643bb96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 746a6e270c8326a706f412c148498b73c6a8c5cae15ff39981bc23f1aaaa72ba

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type viewBacklogVersionFilterRelayQuery$variables = {
  after?: string | null | undefined;
  first: number;
  jiraProjectIds: ReadonlyArray<string>;
};
export type viewBacklogVersionFilterRelayQuery$data = {
  readonly jira: {
    readonly versionsForProjects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly name: string | null | undefined;
          readonly project: {
            readonly key: string;
          } | null | undefined;
          readonly versionId: string;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"versionFilterRelay_softwareFilters">;
      } | null | undefined>;
    };
  };
};
export type viewBacklogVersionFilterRelayQuery = {
  response: viewBacklogVersionFilterRelayQuery$data;
  variables: viewBacklogVersionFilterRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraProjectIds"
},
v3 = {
  "kind": "Literal",
  "name": "filter",
  "value": [
    "UNRELEASED"
  ]
},
v4 = {
  "kind": "Variable",
  "name": "jiraProjectIds",
  "variableName": "jiraProjectIds"
},
v5 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v10 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v11 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v4/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "viewBacklogVersionFilterRelayQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": "versionsForProjects",
                "args": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraVersionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "versionFilterRelay_softwareFilters"
                        },
                        {
                          "concreteType": "JiraVersion",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v5/*: any*/),
                            (v6/*: any*/),
                            {
                              "concreteType": "JiraProject",
                              "kind": "LinkedField",
                              "name": "project",
                              "plural": false,
                              "selections": [
                                (v7/*: any*/)
                              ]
                            },
                            (v8/*: any*/)
                          ]
                        },
                        (v9/*: any*/)
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.versionsForProjects.edges"
                  },
                  (v10/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "jira.versionsForProjects"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "viewBacklogVersionFilterRelayQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v11/*: any*/),
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "versionsForProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      (v12/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  (v9/*: any*/)
                ]
              },
              (v10/*: any*/)
            ]
          },
          {
            "args": (v11/*: any*/),
            "filters": [
              "jiraProjectIds",
              "filter"
            ],
            "handle": "connection",
            "key": "versionBacklogPanelRelay_versionsForProjects",
            "kind": "LinkedHandle",
            "name": "versionsForProjects"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "746a6e270c8326a706f412c148498b73c6a8c5cae15ff39981bc23f1aaaa72ba",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "versionsForProjects"
          ]
        }
      ]
    },
    "name": "viewBacklogVersionFilterRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "816fe123d295a6d9e687adcba29002c6";

export default node;
